var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 13.418L6.06058 19.3574C5.86532 19.5526 5.54874 19.5526 5.35348 19.3574L4.64637 18.6503C4.45111 18.455 4.45111 18.1384 4.64637 17.9432L10.5857 12.0038L4.64637 6.06449C4.45111 5.86923 4.45111 5.55265 4.64637 5.35739L5.35348 4.65028C5.54874 4.45502 5.86532 4.45502 6.06058 4.65028L11.9999 10.5896L17.9393 4.65028C18.1345 4.45502 18.4511 4.45502 18.6464 4.65028L19.3535 5.35738C19.5487 5.55265 19.5487 5.86923 19.3535 6.06449L13.4141 12.0038L19.3535 17.9432C19.5487 18.1384 19.5487 18.455 19.3535 18.6503L18.6464 19.3574C18.4511 19.5526 18.1345 19.5526 17.9393 19.3574L11.9999 13.418Z",
    fill: "#363432"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCloseIcon);
export default __webpack_public_path__ + "static/media/dark-close-icon.b2d1e176cd61ad1a296d51a754c2af10.svg";
export { ForwardRef as ReactComponent };